import React from 'react';
import './style.css';
import Form from 'react-bootstrap/Form';
//import EventListTable from 'components/EventListTable/EventListTable';
// import EventListTableV2 from 'components/EventListTable/EventListTableV2';
import EventList from 'components/EventListTable/EventList';
// import Table from 'react-bootstrap/Table';
// import TableHeader from 'components/Table/TableHeader';
import Button from 'components/Button/Button';
import { searchUrl, user_access_level, org_name, org_account_level, organization_user_access_level, org_friendly_url, user_API, myHeaders_Authorized, channel_list_api, myHeaders_With_Cache_Control, user_entity_uuid } from "Api/Api";
// , UserData, events_list_api, user_Status, location_api, apiUrl
import axios from "axios";
// import { dateConvert, unixDateConversion } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { local_routes } from 'utils/Routes';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import { NavLink } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import home from 'Assets/home.svg';
import Footer from 'components/Footer/Footer';

// import Select from 'react-select';
// import SelectVirtualized from 'react-select-virtualized';

import UserContext from 'store/UserContext';

export default class MyEvents extends React.Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            //org_info: {},
            events_array: [],
            loading: true,
            tableHeader: { 'Title': '', 'Date': '', 'Source': '', 'Published': '', '': '', 'Edit': ''},

            pastData: [],
            upComingData: [],
            draftData: [],

            //user_access_level: '',
            admin_type: null,
            locationGroupData: null,
            channelGroupData: null,
            channelDataTempArr: [],
            locationDataTempArr: [],
            locationBunchData: [],
            channelBunchData: [],
            selectedLocationData: null,
            selectedChannelData: {},
            multipleLocationData: [],
            multipleLocationsArr: [],
            multipleChannelData: [],
            multipleChannelsArr: [],

            singleCityName:null,
            singleChannelName:null,
            singleLocationData:null,
            singleChannelData:null
            
        };
        this.workspace_base_url = "";
        this.Channel_or_Team = "Channel";

        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
          local_routes.channels = local_routes.teams;
          local_routes.managechannel = local_routes.manageteam;
          
          this.Channel_or_Team = "Team";
          
          this.state.tableHeader = { 'Title': '', 'Date': '', 'Source': '', 'Published': '', 'Assets': '', 'Edit': ''};
        }
    }
    
    componentDidMount = async function () {
        //const { user_access_level } = this.state;
        
        // Api Calls for all admin
        if (user_access_level === "admin" && !this.workspace_base_url) {
            // super-admin, public
                    let locations_response = await axios.get(`${searchUrl}locationsearch?coordinates_lat=0&coordinates_lon=0&radius=20038`);
            
            let [channelDataRes, locationDataRes] = await Promise.all([
                axios.get(channel_list_api),
                axios.get(`${searchUrl}locationsearch?coordinates_lat=0&coordinates_lon=0&radius=20038`)
                //axios.get(location_api, myHeaders_Authorized)
            ])
            let channelTempArr = []; let locationTempArr = [];
            if (channelDataRes.data.length !== 0) {
                let channelResponseData = channelDataRes.data;
                this.setState({ channelBunchData: channelDataRes.data })
                if (channelResponseData.entities.length !== 0) {
                    channelResponseData.entities.forEach(function (entity) {
                        channelTempArr.push({ channel_text: entity.entity_name })
                    })
                    //channelTempArr.sort(function (a, b) {
                    //    return a.start_time > b.start_time ? -1 : 1;
                    //});
                    this.setState({ selectedChannelData: channelResponseData.entities[0] })
                }
                this.setState({
                    channelDataTempArr: channelTempArr,
                    channelGroupData: channelTempArr[0]
                })
            }
            if (locationDataRes.data.length !== 0) {
                let locationResponseData = locationDataRes.data.search_query_results.map((data) => data.entity_info);
                locationResponseData = locationResponseData.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);

                //let locationResponseData = locationDataRes.data;
                //this.setState({ locationBunchData: locationDataRes.data })
                this.setState({ locationBunchData: locationResponseData })
                if (locationResponseData.length !== 0) {
                    locationResponseData.forEach(function (entity) {
                        locationTempArr.push({ label: entity.entity_name, location_text: entity.entity_name })
                    })
                    this.setState({ selectedLocationData: locationResponseData[0] })
                }
                
                /*
                if (locationResponseData.entities.length !== 0) {
                    locationResponseData.entities.forEach(function (entity) {
                        locationTempArr.push({ label: entity.entity_name, location_text: entity.entity_name })
                    })
                    //locationTempArr.sort(function (a, b) {
                    //    return a.start_time > b.start_time ? -1 : 1;
                    //});
                    this.setState({ selectedLocationData: locationResponseData.entities[0] })
                }
                */
                this.setState({ locationDataTempArr: locationTempArr, locationGroupData: locationTempArr[0] })
            }
        } else if (this.workspace_base_url && org_account_level === 'premium' && (organization_user_access_level === "admin" || user_access_level === "admin")) {
            // premium workspace, super-admin or org admin
            let [channelDataRes] = await Promise.all([
                axios.get(channel_list_api, myHeaders_Authorized),
                //axios.get(`${apiUrl}organizations/${org_friendly_url}`, myHeaders_Authorized)
            ])
            let channelTempArr = [];
            if (channelDataRes.data.length !== 0) {
                let channelResponseData = channelDataRes.data;
                this.setState({ channelBunchData: channelDataRes.data })
                if (channelResponseData.entities.length !== 0) {
                    channelResponseData.entities.forEach(function (entity) {
                        channelTempArr.push({ channel_text: entity.entity_name })
                    })
                    channelTempArr.sort(function (a, b) {
                        return a.start_time > b.start_time ? -1 : 1;
                    });
                    this.setState({ selectedChannelData: channelResponseData.entities[0] })
                }
                this.setState({
                    channelDataTempArr: channelTempArr,
                    channelGroupData: channelTempArr[0],
                    //org_info: organization_response.data
                })
            }
            
        } else if ((user_access_level === "location_admin" || user_access_level === "channel_admin") && !this.workspace_base_url) {
            // public, location/channel admin
            let locationResponse = {
                data: []
            };
            let channelResponse = {
                data: []
            };

            [locationResponse, channelResponse] = await Promise.all([
                axios.get(`${user_API}/${user_entity_uuid}/locations?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control),
                axios.get(`${user_API}/${user_entity_uuid}/channels?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control)
            ])

            let multipleLocationsTempArr = []; let multipleChannelsTempArr = [];
            let locationName, channelName;
            if (locationResponse.data.length !== 0) {
                this.setState({
                    multipleLocationData: locationResponse.data,
                    singleLocationData: locationResponse.data[0]
                })
                let miltipleLocations = locationResponse.data;
                miltipleLocations.forEach(function (entity) {
                    multipleLocationsTempArr.push(entity.entity_name)
                    locationName = entity.entity_name
                })
            }
            if (channelResponse.data.length !== 0) {
                this.setState({ multipleChannelData: channelResponse.data, singleChannelData: channelResponse.data[0] })
                let multipleChannels = channelResponse.data;
                multipleChannels.forEach(function (entity) {
                    multipleChannelsTempArr.push(entity.entity_name)
                    channelName = entity.entity_name
                })
            }
            this.setState({
                multipleLocationsArr: multipleLocationsTempArr, multipleChannelsArr: multipleChannelsTempArr,
                singleCityName: locationName, singleChannelName: channelName
            })
        } else if (this.workspace_base_url && organization_user_access_level === 'admin') {
            // in workspace, org admin
            /*
            let [organization_response] = await Promise.all([
                axios.get(`${apiUrl}organizations/${org_friendly_url}`, myHeaders_Authorized),
            ])
            this.setState({
                org_info: organization_response.data
            })
            */
        }
        //if (user_Status === 1) {
            //this.setState({ user_access_level: UserData.login_Auth_Res.access_level });
            //this.userPkMet();
        //} else {
        //}
        this.setState({
            loading: false
        })
    }
    
    /*
    // Api calls to get events
    userPkMet = async () => {
        //let eventsResponseData = await axios.get(`${user_API}/${user_entity_uuid}/events?filter[entity_owner_integer][gte]=1&sort[start_time]=desc`, myHeaders_With_Cache_Control);
        let eventsResponseData = await axios.get(`${user_API}/${user_entity_uuid}/events?sort_obj=${encodeURIComponent('{"start_time":"desc"}')}&filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control);
        try {
                if (eventsResponseData.data.length !== 0) {
                    eventsResponseData.data.forEach((item) => {
                        item.editable = true;
                    });
                    this.setState({
                        events_array: eventsResponseData.data,
                        loading: false
                    });
                    

                } else {
                    this.setState({ loading: false });
                }
            } catch (err) {
                this.setState({ loading: false, })
            };
    }
    */
    
    /*
    // Taggle Functionality for publish and unpublish
    togglePublish = async (status, eventData, event_index) => {
        let status_code = (status === true) ? 1 : (status === false) ? 4 : null;
        const payload = {
            status_code: status_code
        };
        if (status_code !== null && status_code !== undefined) {
            await axios.patch(`${apiUrl}events/${eventData.entity_uuid}`, payload);
            let tmp_events_array = [...this.state.events_array];
            tmp_events_array[event_index].status_code = status_code;
            this.setState({
                events_array: tmp_events_array
            });
        }
    }

    getToggledPublishEvnt = async (entity_uuid) => {
        await axios.get(`${events_list_api}/${entity_uuid}`, myHeaders_With_Cache_Control)
    }
    */
    
    // Location select dropdown functionality
    handleLocationForm = (e) => {
        const { locationBunchData } = this.state;
        this.setState({
            locationGroupData: e.target.value
        })
        let selectedLocationTempArr = []
        if (locationBunchData.length > 0) {
            
            locationBunchData.find(function (element) {
                if (element.entity_name === e.target.value) {
                    selectedLocationTempArr.push(element)
                }
            })
            this.setState({ selectedLocationData: selectedLocationTempArr[0] })
        }

        /*
        if (locationBunchData.entities !== 0) {
            // eslint-disable-next-line
            locationBunchData.entities.find(function (element) {
                if (element.entity_name === e.target.value) {
                    selectedLocationTempArr.push(element)
                }
            })
            this.setState({ selectedLocationData: selectedLocationTempArr[0] })
        }
        */
    }
      // Channel select dropdown functionality
    handleChannelForm = (e) => {
        const { channelBunchData } = this.state;
        this.setState({
            channelGroupData: e.target.value
        })
        let selectedChannelTempArr = []
        if (channelBunchData.entities !== 0) {
            // eslint-disable-next-line
            channelBunchData.entities.find(function (element) {
                if (element.entity_name === e.target.value) {
                    selectedChannelTempArr.push(element)
                }
            })
            this.setState({ selectedChannelData: selectedChannelTempArr[0] })
        }
    }
    
    // onclick Location dropdown functionality
    onClickLocation = (item) => {
        const { multipleLocationData } = this.state;
        let mutilLocationSelect = [];
        // eslint-disable-next-line
        multipleLocationData.find(function (element) {
            if (element.entity_name === item) {
                mutilLocationSelect.push(element)
            }
        })
        let source = {
            entity_type: 'locations',
            entity_uuid: mutilLocationSelect[0].entity_uuid,
            referrer: `${this.workspace_base_url}${local_routes.myevents}`
        }
        //let source = {...mutilLocationSelect[0]};
        //source.entity_type = 'locations';
        //source.referrer = `${this.workspace_base_url}${local_routes.myevents}`
            
        this.props.history.push({
            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
            data: {
                source
            }
            //data: mutilLocationSelect[0]
        })
    }
    
    // Onclick Channel dropdown functionality
    onClickChannelData = (item) => {
        const { multipleChannelData } = this.state;
        let mutilChannelSelect = [];
        // eslint-disable-next-line
        multipleChannelData.find(function (element) {
            if (element.entity_name === item) {
                mutilChannelSelect.push(element)
            }
        })
        let source = {
            entity_type: 'channels',
            entity_uuid: mutilChannelSelect[0].entity_uuid,
            referrer: `${this.workspace_base_url}${local_routes.myevents}`
        }
        //let source = {...mutilChannelSelect[0]};
        //source.entity_type = 'channels';
        //source.referrer = `${this.workspace_base_url}${local_routes.myevents}`

        this.props.history.push({
            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
            data: {
                source
            }
            //data: mutilChannelSelect[0]
        })
    }

    /*
    OnDeleteEvent = async (event_uuid, event_index) => {
        let patch_obj = {
            status_code: 2
        };
        await axios.patch(`${apiUrl}events/${event_uuid}`,patch_obj);
        let tmp_events_array = [...this.state.events_array];
        tmp_events_array.splice(event_index,1); // remove from array
        this.setState({
            events_array: tmp_events_array
        });
    }
    */

    render() {

        if (this.state.loading === true) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            )
        }

        //console.log("RENDER",user_access_level,this.workspace_base_url);
        return (
            <div>
                {/* Events List Section Starts here */}
                <div className="editCitySec container">
                    <div className="editCityMenu ">
                        <div className="pkListContainer eventListContainer myevents-list">
                            <div className="myPkList">
                                <h2 className="myPkHeading">My Events</h2>
                                <div className="buttonS">
                                    { user_access_level === 'admin' &&
                                        // super-admin
                                        <React.Fragment>
                                        { !this.workspace_base_url ?
                                            // public super-admin options
                                            <div className="">
                                                <div className="d-flex align-items-center">
                                                    <div className="mr-3 mt-2">
                                                        <Form>
                                                            <Form.Group className="mb-0">
                                                                <div className="">
                                                                    {/*
                                                                        <SelectVirtualized
                                                                          className=''
                                                                          classNamePrefix=''
                                                                          //ref={this.select_ref}
                                                                          //isDisabled={!this.props.editable}
                                                                          //isDisabled={true}
                                                                          //isOptionDisabled={true}
                                                                          closeMenuOnSelect={true}
                                                                          value={null}
                                                                          defaultValue={this.state.locationGroupData}
                                                                          onChange={this.handleLocationForm}
                                                                          options={this.state.locationDataTempArr}
                                                                          isMulti={false}  
                                                                        />
                                                                    */}
                                                                
                                                                    
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        onChange={this.handleLocationForm}
                                                                        defaultValue={this.state.locationGroupData}
                                                                    >
                                                                        {
                                                                            this.state.locationDataTempArr.map((data, index) =>
                                                                                <option key={index}>{data.location_text}</option>
                                                                            )
                                                                        }
                                                                    </Form.Control>
                                                                    
                                                                </div>
                                                            </Form.Group>
                                                        </Form>
                                                    </div>
                                                    <NavLink
                                                        to={{
                                                            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                            data: {
                                                                source: {
                                                            
                                                                    entity_type: 'locations',
                                                                    entity_uuid: this.state.selectedLocationData.entity_uuid,
                                                                    referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                                }
                                                            }
                                                        }}>
                                                        <Button
                                                            		
                                                            theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                            Create City Event
                                                        </Button>
                                                    </NavLink>
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <div className="mr-3 mt-2">
                                                        <Form>
                                                            <Form.Group className="mb-0">
                                                                <div className="">
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        onChange={this.handleChannelForm}
                                                                        defaultValue={this.state.channelGroupData}
                                                                    >
                                                                        {
                                                                            this.state.channelDataTempArr.map((item, index) =>
                                                                                <option key={index}>{item.channel_text}</option>
                                                                            )
                                                                        }
                                                                    </Form.Control>
                                                                </div>
                                                            </Form.Group>
                                                        </Form>
                                                    </div>
                                                    <NavLink
                                                        to={{
                                                            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                            data: {
                                                                source: {
                                                                    entity_type: 'channels',
                                                                    entity_uuid: this.state.selectedChannelData.entity_uuid,
                                                                    referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <Button
                                                            		
                                                            theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                            Create {this.Channel_or_Team} Event
                                                        </Button>
                                                    </NavLink>
                                                </div>
                                            </div>
                                            // end public super-admin options
                                        :
                                            // workspace super-admin options
                                            <React.Fragment>
                                            { org_account_level === 'premium' ?
                                                // multiple channels
                                                <div className="">
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-3 mt-2">
                                                            <Form>
                                                                <Form.Group className="mb-0">
                                                                    <div className="">
                                                                        <Form.Control
                                                                            as="select"
                                                                            required
                                                                            onChange={this.handleChannelForm}
                                                                            defaultValue={this.state.channelGroupData}
                                                                        >
                                                                            {
                                                                                this.state.channelDataTempArr.map((item, index) =>
                                                                                    <option key={index}>{item.channel_text}</option>
                                                                                )
                                                                            }
                                                                        </Form.Control>
                                                                    </div>
                                                                </Form.Group>
                                                            </Form>
                                                        </div>
                                                        <NavLink
                                                            to={{
                                                                pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                                data: {
                                                                    source: {
                                                                        entity_type: 'channels',
                                                                        entity_uuid: this.state.selectedChannelData.entity_uuid,
                                                                        referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            <Button
                                                                // OnClickMet={() => this.createEvent()}		
                                                                theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                                Create {this.Channel_or_Team} Event
                                                            </Button>
                                                        </NavLink>
                                                    </div>                                                    
                                                </div>
                                                // end super-admin workspace premium options
                                                :
                                                // super-admin workspace 'standard' - no channels
                                                <div>
                                                    <NavLink
                                                        to={{
                                                            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                            data: {
                                                                source: {
                                                                    entity_type: 'organizations',
                                                                    referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <Button
                                                            theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                            Create {org_name} Event
                                                        </Button>
                                                    </NavLink>
                                                </div>
                                            }
                                            </React.Fragment>
                                            // end workspace super-admin options
                                        }
                                        </React.Fragment>
                                        // end super-admin options
                                    } 
                                    { (this.workspace_base_url && user_access_level !== 'admin' && organization_user_access_level === 'admin') &&
                                        // org admin options
                                        <React.Fragment>
                                        { org_account_level === 'premium' ?
                                            // premium workspace - multiple channels
                                            <div className="">
                                                <div className="d-flex align-items-center">
                                                    <div className="mr-3 mt-2">
                                                        <Form>
                                                            <Form.Group className="mb-0">
                                                                <div className="">
                                                                    <Form.Control
                                                                        as="select"
                                                                        required
                                                                        onChange={this.handleChannelForm}
                                                                        defaultValue={this.state.channelGroupData}
                                                                    >
                                                                        {
                                                                            this.state.channelDataTempArr.map((item, index) =>
                                                                                <option key={index}>{item.channel_text}</option>
                                                                            )
                                                                        }
                                                                    </Form.Control>
                                                                </div>
                                                            </Form.Group>
                                                        </Form>
                                                    </div>
                                                    <NavLink
                                                        to={{
                                                            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                            data: {
                                                                source: {
                                                                    entity_type: 'channels',
                                                                    entity_uuid: this.state.selectedChannelData.entity_uuid,
                                                                    referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <Button
                                                            // OnClickMet={() => this.createEvent()}		
                                                            theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                            Create {this.Channel_or_Team} Event
                                                        </Button>
                                                    </NavLink>
                                                </div>                                                    
                                            </div>
                                            // end workspace premium options
                                            :
                                            // workspace 'standard' - no channels
                                            <div>
                                                <NavLink
                                                    to={{
                                                        pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                        data: {
                                                            source: {
                                                                entity_type: 'organizations',
                                                                //entity_uuid: this.state.org_info.entity_uuid,
                                                                referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <Button
                                                        theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                        Create {org_name} Event
                                                    </Button>
                                                </NavLink>
                                            </div>
                                        }
                                        </React.Fragment>
                                        // end org admin
                                    } 
                                    { (user_access_level === "location_admin" && !this.workspace_base_url) &&
                                        // location admin
                                        <div>
                                            {
                                                this.state.multipleLocationsArr.length <= 1 ?
                                                    <NavLink
                                                        to={{
                                                            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                            data: {
                                                                source: {
                                                                    //...this.state.singleLocationData,
                                                                    entity_uuid: this.state.singleLocationData.entity_uuid,
                                                                    entity_type: 'locations',
                                                                    referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                                }
                                                            }
                                                        }}>
                                                        <Button
                                                            theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                            Create {this.state.singleCityName} Event
                                                        </Button>
                                                    </NavLink>
                                                    :
                                                    <Dropdown className="profile-dropdown">
                                                        <Dropdown.Toggle id="dropdown-basic">
                                                            Create Event
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {
                                                                this.state.multipleLocationsArr.map((item,index) =>
                                                                    <React.Fragment>
                                                                        <Dropdown.Item key = {index} onClick={() => this.onClickLocation(item)}>
                                                                            Create {item} Event
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Divider />
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                            }
                                        </div>
                                        // end location_admin
                                    }
                                    { (user_access_level === "channel_admin" && !this.workspace_base_url) &&
                                        // non-org channel admin
                                        <div>
                                            {
                                                this.state.multipleChannelsArr.length <= 1 ?
                                                    <NavLink
                                                        to={{
                                                            pathname: `${this.workspace_base_url}${local_routes.manageevent}`,
                                                            data: {
                                                                source: {
                                                                    entity_type: 'channels',
                                                                    entity_uuid: this.state.singleChannelData.entity_uuid,
                                                                    referrer: `${this.workspace_base_url}${local_routes.myevents}`
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <Button
		
                                                            theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 event-create">
                                                            Create {this.state.singleChannelName} Event
                                                        </Button>
                                                    </NavLink>
                                                    :
                                                    <Dropdown className="profile-dropdown">
                                                        <Dropdown.Toggle id="dropdown-basic">
                                                            Create Event
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {
                                                                this.state.multipleChannelsArr.map((item,index) =>
                                                                    <React.Fragment>
                                                                        <Dropdown.Item key = {index} onClick={() => this.onClickChannelData(item)}>
                                                                            Create {item} Event
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Divider/>
                                                                    </React.Fragment>
                                                                )
                                                            }
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                            }

                                        </div>
                                        // end non-org channel admin
                                    }
                                </div>
                            </div>
                            {
                                ((!this.workspace_base_url && this.context.events && this.context.events.length === 0) || (this.workspace_base_url && (organization_user_access_level !== "admin" && user_access_level !== "admin"))) ?
                                <div className="empty-event">
                                    <EmptyMessage empty_message="Sorry access not allowed" />
                                </div>
                                :
                                null
                            }

                            <EventList
                              //user_data={this.user_data}
                              source_info={{entity_uuid: user_entity_uuid,entity_type:'users'}}
                              referrer={`${this.workspace_base_url}${local_routes.myevents}`}
                            />

                            {/*                            
                            { this.state.events_array.length > 0 ?
                                <div className="table-boby channel-events-list">
                                    <Table id='Draft' className="table-responsive">
                                        <tbody>

                                            <TableHeader headerType="All" headerStatus={true} tableHeader={this.state.tableHeader} listLength={this.state.events_array.length} />

                                            {
                                                this.state.events_array.map((item, i) => {
                                                    return (
                                                        <EventListTableV2
                                                            key={item.entity_uuid}
                                                            index={i} // so callbacks can easily change state to reflect actions
                                                            event_info={item}
                                                            //source_info={{...this.props.org_data,entity_type:'organizations'}}
                                                            org_info={{entity_name:org_name}}
                                                            referrer={`${this.workspace_base_url}${local_routes.myevents}`}
                                                            workspace_base_url={this.workspace_base_url}
                                                            togglePublish={this.togglePublish}
                                                            OnDeleteEvent={this.OnDeleteEvent}
                                                        />
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                :
                                <div className="empty-event">
                                    <EmptyMessage empty_message="No events created yet!" />
                                </div>                                
                            }
                            */}
                                       

                        </div>
                    </div>
                </div>
                {/* Events List Esction Endds here */}
                <div style={{display:'block'}} className="myPkFooter">
                    <Footer
                        homeImg={home}
                        homeImgRef={this.workspace_base_url ? this.workspace_base_url : "/"}
                        breadcrumbSubPage="My Events"
                    />
                </div>
            </div>
        );
        
    }
}
